import { render, staticRenderFns } from "./DatabaseBackupRestore.vue?vue&type=template&id=4e519ec7&scoped=true"
import script from "./DatabaseBackupRestore.vue?vue&type=script&lang=ts"
export * from "./DatabaseBackupRestore.vue?vue&type=script&lang=ts"
import style0 from "./DatabaseBackupRestore.vue?vue&type=style&index=0&id=4e519ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e519ec7",
  null
  
)

export default component.exports